/*
  Trevior PDP gallery: previous / next arrows over the main picture and a fade when the picture changes.
  The buttons are rendered by snippets/product-media-gallery.liquid. They do not scroll anything themselves:
  they click the neighbouring thumbnail, so the gallery's own logic (active picture, video start, thumbnail strip) stays in one place.
  The fade is plain CSS (assets/trevior-gallery-arrows.css); this file only switches it on after the first interaction,
  so the picture shown on page load is not animated.
*/
if (!window.treviorGalleryArrows) {
  window.treviorGalleryArrows = true;

  // capture phase: the attribute is set before the gallery's own handler moves the active picture
  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest('[data-trevior-gallery-arrow], .thumbnail-list__item button');
      const gallery = trigger && trigger.closest('media-gallery');
      if (gallery) gallery.setAttribute('data-trevior-fade', '');
    },
    true
  );

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-trevior-gallery-arrow]');
    if (!arrow) return;

    const gallery = arrow.closest('media-gallery');
    const thumbnails = gallery && gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbnails) return;

    const items = [...thumbnails.querySelectorAll('.thumbnail-list__item[data-target]')].filter(
      (item) => !item.classList.contains('thumbnail-list_item--variant')
    );
    if (items.length < 2) return;

    const current = items.findIndex((item) => item.querySelector('button').getAttribute('aria-current') === 'true');
    const step = Number(arrow.dataset.treviorGalleryArrow);
    const target = items[(Math.max(current, 0) + step + items.length) % items.length];
    target.querySelector('button').click();
  });
}
